if (!customElements.get('buck-header')) {
  customElements.define('buck-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.menu = this.querySelector('[data-buck-chrome-menu]');
      this.toggle = this.querySelector('[data-buck-chrome-toggle]');
      this.panel = this.querySelector('[data-buck-drawer-panel]');
      if (!this.menu || !this.toggle || !this.panel) return;
      this.mobile = window.matchMedia('(max-width: 1100px)');
      this.setAttribute('data-drawer-ready', '');
      const update = () => {
        if (this.menu.open && !this.mobile.matches) this.menu.open = false;
        this.toggle.setAttribute('aria-expanded', String(this.menu.open));
        this.toggle.setAttribute('aria-label', this.menu.open ? this.dataset.closeLabel : this.dataset.openLabel);
        if (this.menu.open) this.activateDrawer();
        else this.releaseDrawer();
      };
      this.menu.addEventListener('toggle', update, { signal });
      this.toggle.addEventListener('click', () => queueMicrotask(update), { signal });
      document.addEventListener('keydown', event => {
        if (this.menu.open && event.key === 'Tab') {
          const focusable = this.focusableItems();
          if (!focusable.length) { event.preventDefault(); this.panel.focus(); return; }
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && (document.activeElement === first || !this.panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || !this.panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
          return;
        }
        if (event.key !== 'Escape') return;
        const dropdown = event.target.closest('.buck-nav__children[open]');
        if (dropdown && this.contains(dropdown)) {
          dropdown.open = false;
          dropdown.querySelector('summary').focus();
        } else if (this.menu.open) {
          event.preventDefault();
          this.closeMenu(true);
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) {
          this.closeMenu();
          this.querySelectorAll('.buck-nav__children[open]').forEach(details => { details.open = false; });
        }
      }, { signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-buck-drawer-close]')) this.closeMenu(true);
        else if (event.target.closest('a')) this.closeMenu();
      }, { signal });
      document.addEventListener('focusin', event => {
        if (this.drawerActive && !this.panel.contains(event.target)) (this.focusableItems()[0] || this.panel).focus();
      }, { signal });
      this.mobile.addEventListener('change', () => this.closeMenu(), { signal });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(this)) this.closeMenu(); }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!event.detail?.blockId || !window.matchMedia('(max-width: 1100px)').matches) return;
        if ([...this.menu.querySelectorAll('[data-buck-navigation-block]')].some(el => el.dataset.buckNavigationBlock === event.detail.blockId)) {
          this.menu.open = true;
          update();
        }
      }, { signal });
      if (this.querySelector('[data-buck-cart-count]') && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
            if (!response.ok) return;
            const cart = await response.json();
            if (this.isConnected) this.querySelectorAll('[data-buck-cart-count]').forEach(el => { el.textContent = cart.item_count; });
          } catch { /* Navigation to the native cart remains available if a count refresh fails. */ }
        });
      }
      update();
    }
    focusableItems() {
      return [...this.panel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter(element => element.getClientRects().length && !element.closest('[hidden]'));
    }
    activateDrawer() {
      if (this.drawerActive) return;
      this.drawerActive = true;
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-modal', 'true');
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('buck-drawer-open');
      this.parentElement.classList.add('buck-header-drawer-active');
      (this.focusableItems()[0] || this.panel).focus({ preventScroll: true });
    }
    releaseDrawer() {
      if (!this.drawerActive) return;
      this.drawerActive = false;
      this.panel.removeAttribute('role');
      this.panel.removeAttribute('aria-modal');
      document.body.style.overflow = this.savedOverflow || '';
      document.body.classList.remove('buck-drawer-open');
      this.parentElement?.classList.remove('buck-header-drawer-active');
    }
    closeMenu(restoreFocus = false) {
      if (!this.menu) return;
      this.menu.open = false;
      this.releaseDrawer();
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-label', this.dataset.openLabel);
      if (restoreFocus && this.toggle.isConnected) this.toggle.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.releaseDrawer();
      this.controller?.abort();
      this.controller = null;
      this.unsubscribeCart?.();
      this.unsubscribeCart = null;
    }
  });
}
